import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'

function getInitialLocale() {
  try {
    const userRaw = localStorage.getItem('user')
    if (userRaw) {
      const u = JSON.parse(userRaw)
      if (u && u.preferred_language) return u.preferred_language
    }
  } catch (_) { /* ignore */ }
  const stored = localStorage.getItem('app_locale')
  if (stored) return stored
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: { en },
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
})

export async function loadLocaleAsync(locale) {
  if (i18n.global.availableLocales.includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('app_locale', locale)
    return
  }
  try {
    const messages = await import(`@/locales/${locale}.json`)
    i18n.global.setLocaleMessage(locale, messages.default || messages)
    i18n.global.locale.value = locale
    localStorage.setItem('app_locale', locale)
  } catch (e) {
    console.warn('[i18n] Failed to load locale', locale, e)
  }
}

export default i18n
